import { StyleSheet } from "react-native";
import { theme } from "../../theme";
export const styles = StyleSheet.create({
    heading: {
        paddingLeft: theme.spacing.small,
        paddingRight: theme.spacing.small,
        fontFamily: "ProximaBold",
    },
    detailsContainer: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
    },
    detailsToggleWrapper: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
    },
    toggleContainer: {
        alignItems: "center",
        flexDirection: "row",
        marginVertical: theme.spacing.small,
    },
    clipboardMessage: {
        marginRight: theme.spacing.small,
    },
    clipboardWrapper: {
        flexDirection: "row",
    },
    toggleContainerLeft: {
        display: "flex",
        flexDirection: "row",
        width: "100%",
    },
    detailsHeading: {
        paddingLeft: theme.spacing.small,
    },
    errorStack: {
        maxHeight: "60%",
        marginTop: theme.spacing.small,
        marginBottom: theme.spacing.small,
        padding: theme.spacing.xsmall2,
    },
    errorStackMessage: {
        padding: theme.spacing.xsmall2,
        color: theme.colors.negative.base,
    },
    retryIcon: {
        marginRight: theme.spacing.small,
        fontFamily: "ProximaBold",
    },
    panel: {
        flex: 1,
        paddingVertical: "20%",
        justifyContent: "center",
    },
});
//# sourceMappingURL=DefaultErrorComponent.styles.js.map